module.exports = __webpack_public_path__ + "static/media/auth-alt.81c0aca6.png";